import request from "@/http/request"
import {
    getSessionAddName,
    addSession,
    editSession,
    deleteSession,
    getPlanSessionList,
    queryPaperByCourseCode,
    getPlanPlaceList,
    getEditSession,
    getPlanPlaceCourse,
    getChainSessionList,
    getChainClassList,
    getIpAnalysis,
    getIpAnalysisTitle,
    getIpAnalysisDetail,
    getCourseListBySession,
    getOtherClasses,
    getClassesStudentCount,
    getClassesStudentInfo,
    saveChangePlanClass,
    queryExamOrderCode,
    getIpAnalysisPlace,
    getIpAnalysisSession,
    getIpAnalysisClass,
    addTimeStudentCount,
    addTimeBatch,
    addTimeSingle,
    getSessionConfig,
    saveSessionConfig,
    copySessionConfig
} from '@/http/api'


export const copySessionConfigAPI = (data) => {
    return request({
        url: copySessionConfig,
        data
    })
}

export const saveSessionConfigAPI = (data) => {
    return request({
        url: saveSessionConfig,
        data
    })
}


export const getSessionConfigAPI = (data) => {
    return request({
        url: getSessionConfig,
        data
    })
}

export const addTimeSingleAPI = (data) => {
    return request({
        url: addTimeSingle,
        data
    })
}

export const addTimeBatchAPI = (data) => {
    return request({
        url: addTimeBatch,
        data
    })
}

export const addTimeStudentCountAPI = (data) => {
    return request({
        url: addTimeStudentCount,
        data
    })
}

export const getIpAnalysisClassAPI = (data) => {
    return request({
        url: getIpAnalysisClass,
        data
    })
}

export const getIpAnalysisSessionAPI = (data) => {
    return request({
        url: getIpAnalysisSession,
        data
    })
}

export const getIpAnalysisPlaceAPI = (data) => {
    return request({
        url: getIpAnalysisPlace,
        data
    })
}

export const getSessionName = (data) => {
    return request({
        url: getSessionAddName,
        data
    })
}
export const addSection = (data) => {
    return request({
        url: addSession,
        data
    })
}
export const editSection = (data) => {
    return request({
        url: editSession,
        data
    })
}
export const PlanPlaceCourse = (data)=>{
    return request({
        url: getPlanPlaceCourse,
        data
    })
}
export const getSectionList = (data) => {
    return request({
        url: getPlanSessionList,
        data
    })
}
export const getPaperFn = (data) => {
    return request({
        url: queryPaperByCourseCode,
        data
    })
}
export const getPlanSite = (data) => {
    return request({
        url: getPlanPlaceList,
        data
    })
}
export const getSingleSection = (data) => {
    return request({
        url: getEditSession,
        data
    })
}
export const deleteSessionFn = (data) => {
    return request({
        url: deleteSession,
        data
    })
}
export const getChainSessionDate = (data) => {
    return request({
        url: getChainSessionList,
        data
    })
}
export const getChainClassDate = (data) => {
    return request({
        url: getChainClassList,
        data
    })
}
export const getIpAnalysisFn = (data) => {
    return request({
        url: getIpAnalysis,
        data
    })
}
export const getIpAnalysisTitleText = (data) => {
    return request({
        url: getIpAnalysisTitle,
        data
    })
}
export const getIpAnalysisDetailList = (data) => {
    return request({
        url: getIpAnalysisDetail,
        data
    })
}
export const getCourseListBySessionList = (data) => {
    return request({
        url: getCourseListBySession,
        data
    })
}
export const getOtherClassesFn = (data) => {
    return request({
        url: getOtherClasses,
        data
    })
}
export const getClassesStudentCountFn = (data) => {
    return request({
        url: getClassesStudentCount,
        data
    })
}
export const getClassesStudentInfoFn = (data) => {
    return request({
        url: getClassesStudentInfo,
        data
    })
}
export const saveChangePlanClassFn = (data) => {
    return request({
        url: saveChangePlanClass,
        data
    })
}
export const queryExamOrderCodeFn = (data) => {
    return request({
        url: queryExamOrderCode,
        data
    })
}